import React from "react";
import BoxedLayout from "../../parts/layout/BoxedLayout";

export default function Transition(props){
    
    return (
        <div className="App min-h-screen bg-gradient-to-r from-sky-100 to-white">
        <BoxedLayout content={
            <div className="container mx-auto px-4 mt-6">
                <div className="flex flex-col items-center">
                    <div className="w-full max-w-5xl bg-white bg-opacity-80 p-6 rounded-lg shadow-lg">
                        <div className="text-5xl text-left mb-12">                            
                            <div className="mt-6 text-xl text-gray-600 font-raleway">
                                {props.message}
                            </div>                           
                        </div>
                    </div>
                    
                </div>
            </div>
            
        } />
        </div>
    );
}